import LoginForm from "../../Components/LoginForm/LoginForm";

export const LoginPage = function() {
    return (
        <div>
            <LoginForm/>
        </div>
    )
}